<template>
  <div class="layout-auth d-flex flex-column">
    <Header :fullHeader="false"></Header>
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default {
  components: {
    Header,
    Footer
  },
  data: () => ({
    errorCount: 0,
    pageMessage: false
  }),
  computed: {
    error() {
      return this.$store.state.error;
    }
  },
  watch: {
    error(fbError = false) {
      this.$toast(fbError || 'Что-то пошло не так', {title: 'Ошибка', variant: 'warning'})
    }
  }
};
</script>

<style>
.layout-auth {
  --layout-padding: 75px;
  padding-top: var(--layout-padding);
  height: 100vh;
  background-color: #f5f5f5;
}
</style>
